var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.56201,
    y: 2.29199,
    width: 7.14638,
    height: 7.55089,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 0C2.63027 0 0 2.63027 0 5.875C0 9.11973 2.63027 11.75 5.875 11.75C9.11973 11.75 11.75 9.11973 11.75 5.875C11.75 2.63027 9.11973 0 5.875 0ZM9.24742 8.08229L8.08229 9.24742L5.875 7.04013L3.66771 9.24742L2.50258 8.08229L4.70987 5.875L2.50258 3.66771L3.66771 2.50258L5.875 4.70987L8.08229 2.50258L9.24742 3.66771L7.04013 5.875L9.24742 8.08229Z",
    fill: "#F63E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.2b5281733c06d8c834751127f765233a.svg";
export { ForwardRef as ReactComponent };